export default {
    namespaced: true,

    state: {
        fileList: []
    },

    mutations: {
        updateFileList(state, data) {
            state.fileList = data;
        }
    }
};